import React from "react"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import { API_FORM } from "../../../api"
import Thumb from "./Thumb"
import { AddIcon } from "../../Icons"
import "./ImageField.css"

class ImageField extends React.Component {
  state = {
    uploading: false,
    hash: Date.now()
  }

  active = false

  componentDidMount() {
    this.active = true
  }

  componentWillUnmount() {
    this.active = false
  }

  render() {
    const {
      field: { name, value },
      form: { values, setFieldValue },
      icon: Icon,
      source,
      onDropCallBack,
      className,
      disabled
    } = this.props

    return (
      <span className="ImageField">
        <Dropzone
          className={`drop-zone ${className}`}
          disabled={disabled}
          accept="image/*"
          multiple={false}
          maxSize={2097152}
          onDrop={async acceptedFiles => {
            // do nothing if no files
            if (acceptedFiles.length === 0) {
              return
            }
            // on drop we add to the existing files
            this.setState({ uploading: true })
            try {
              // console.log(acceptedFiles[0])
              const formData = new FormData()
              formData.append("image", acceptedFiles[0])
              formData.append("source", source)
              formData.append("photo_url", values[name] || "")
              const newPhoto = await API_FORM.post("/images/upload", formData)
              this.setState({ hash: Date.now() })
              newPhoto && setFieldValue(name, newPhoto.data.url)
              onDropCallBack && onDropCallBack(newPhoto.data.url)
            } catch (error) {
              console.log("Photo Upload Error: ", error.response || error)
            } finally {
              this.active && this.setState({ uploading: false })
            }
          }}
          onDropRejected={() => {
            console.log("Drop rejected.")
          }}
        >
          {() => {
            if (this.state.uploading) {
              return <div>Uploading....</div>
            }

            if (value) {
              return <Thumb url={`${value}?${this.state.hash}`} />
            }

            return (
              (Icon && <Icon />) || (
                <span className="drop-zone-placeholder">
                  <AddIcon />
                </span>
              )
            )
          }}
        </Dropzone>
      </span>
    )
  }
}

ImageField.propTypes = {
  source: PropTypes.string.isRequired
}

export default ImageField
